import React from 'react';
import {Route, Router, Switch} from "react-router";
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
import * as Pages from '../pages';
import {history} from "../vendors/redux/store";
import Layout from '../layout';
import Overrides from './overridesTheme';

declare global {
    interface Window {
        ga: any;
    }
}

window.ga = window.ga || false;
const theme = createMuiTheme(Overrides);


history.listen((location) => {
    if (window.ga && typeof window.ga === 'function') {
        window.ga('set', 'page', location.pathname + location.search);
        window.ga('send', 'pageview');
    }
});

function App() {
    return (
        <ThemeProvider theme={theme}>
            <div className="app" id="consumer-app">
                <div className={'content'}>
                    <Router history={history}>
                        <Switch>
                            <Route path="/" exact={true} component={Pages.CreateCase}/>
                            <Route path="/login" component={Pages.Login}/>
                            <Route path="/unsubscribe/:t/:mt/:action" component={Pages.Unsubscribe}/>
                            <Route path="/forgot-password/:token" component={Pages.ForgotPassword}/>
                            <Route path="/forgot-password" component={Pages.ForgotPassword}/>
                            <Layout history={history}>
                                <Route path="/dashboard" component={Pages.Dashboard}/>
                                <Route path="/find-lawyer" component={Pages.CreateCaseLoggedIn}/>
                                <Route path="/faq" component={Pages.Faq}/>
                                <Route path="/case/:case_uid" component={Pages.SingleCase}/>
                                <Route path="/profile" component={Pages.Profile}/>
                            </Layout>
                            <Route path="/404" component={Pages.NotFound}/>
                            <Route path='*' exact={true} component={Pages.NotFound}/>
                        </Switch>
                    </Router>
                </div>
            </div>
        </ThemeProvider>
    );
}

export default App;
